/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { proposalsGetApiV3MetricsLatestProposalId } from "../../funcs/proposalsGetApiV3MetricsLatestProposalId.js";
import { formatResult, ToolDefinition } from "../tools.js";

export const tool$proposalsGetApiV3MetricsLatestProposalId: ToolDefinition = {
  name: "proposals-get-api-v3-metrics-latest-proposal-id",
  description: ``,
  tool: async (client, ctx) => {
    const [result, apiCall] = await proposalsGetApiV3MetricsLatestProposalId(
      client,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
